var render = function render(){var _vm=this,_c=_vm._self._c;return _c('td',[_c('div',{staticClass:"d-flex align-center"},[_c('v-progress-linear',{staticStyle:{"width":"100px","margin-right":"10px"},attrs:{"value":_vm.value,"height":"25","rounded":"","dark":_vm.dark,"color":_vm.getColor()}}),_c('strong',{style:({ color: _vm.getTextColor() })},[_vm._v(_vm._s(_vm.value)+"%")])],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }